export default "__VITE_ASSET__8GZIS11N__"